module.exports = __webpack_public_path__ + "static/media/close-circle.eeda95c5.svg";